export const USER_QUERY_KEYS = {
  GET_USER_LIST: 'get-user-list',
  USERS: 'users-list',
};
